import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const User: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M5.5 19C7 16.5 9 15.5 12 15.5C15 15.5 17 16.5 18.5 19"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
